import { Spinner } from '@/app/components/Spinner/Spinner';

export const PaymentMethodsImportLoader = () => (
  <div className="h-[250] w-full rounded-[8px] mb-[24px]" aria-label="Loading payment methods">
    <div role="status" className="flex items-center justify-center h-full">
      <Spinner className="w-[32px] h-[32px] animate-spin" />
    </div>
  </div>
);
